import { Container } from '@chakra-ui/react'

export default Container
